module.exports = __webpack_public_path__ + "static/media/ic_biometric.d11b3ac9.svg";